import Link from "next/link";
import { useRouter } from "next/router";

export default function LocaleSwitch() {
  const router = useRouter();
  const pathname = router.pathname;
  const locale = router.locale;

  return (
    <div className="text-xl uppercase">
      <Link href={{ pathname, query: router.query }} locale="de">
        <a className={`${locale === "de" ? "underline" : ""}`}>de</a>
      </Link>
      <span> | </span>
      <Link href={{ pathname, query: router.query }} locale="en">
        <a className={`${locale === "en" ? "underline" : ""}`}>en</a>
      </Link>
    </div>
  );
}
